import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import { Wrapper } from '../../apps/homepage/Wrapper';
import css from './ShopBlocks.module.scss';
import newLineToBreakTag from '../../utils/strings/newLineToBreakTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

var Block = function Block(_ref) {
  var image = _ref.image,
      title = _ref.title,
      color = _ref.titleColor,
      url = _ref.url;
  return /*#__PURE__*/_jsxs("a", {
    className: css.block,
    href: url,
    children: [/*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
      sizes: [480, 600, 900, 1200, 1600],
      wrap: false
    })), title && /*#__PURE__*/_jsx("h4", {
      className: css.blockTitle,
      style: {
        color: color
      },
      dangerouslySetInnerHTML: {
        __html: newLineToBreakTag(title)
      }
    })]
  });
};

Block.propTypes = {
  id: PropTypes.string.isRequired,
  image: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};
export var ShopBlocks = function ShopBlocks(_ref2) {
  var blocks = _ref2.blocks,
      displayBackground = _ref2.displayBackground,
      title = _ref2.title;
  return /*#__PURE__*/_jsx(Wrapper, {
    wrap: displayBackground,
    children: /*#__PURE__*/_jsxs("section", {
      className: css.root,
      children: [title && /*#__PURE__*/_jsx("h3", {
        className: css.title,
        dangerouslySetInnerHTML: {
          __html: newLineToBreakTag(title)
        }
      }), /*#__PURE__*/_jsx("div", {
        className: css.blocks,
        children: blocks.edges.map(function (_ref3) {
          var node = _ref3.node;
          return /*#__PURE__*/_createElement(Block, _objectSpread(_objectSpread({}, node), {}, {
            key: node.id
          }));
        })
      })]
    })
  });
};
ShopBlocks.propTypes = {
  title: ''
};
ShopBlocks.propTypes = {
  blocks: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({
      node: PropTypes.shape(_objectSpread({}, Block.propTypes)).isRequired
    })).isRequired
  }).isRequired,
  displayBackground: PropTypes.bool,
  title: PropTypes.string
};